import React, { useState } from 'react'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Zoom,
} from '@mui/material'
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  makeStyles,
  TableSortLabel,
} from '@material-ui/core'
import endorsementImg from 'src/assets/Endorsement_images/Group_587.svg'
import submittedImg from 'src/assets/Endorsement_images/Group_588.svg'
import ApprovedImg from 'src/assets/Endorsement_images/Group_432.svg'
import blueApprovedImg from 'src/assets/Endorsement_images/blueApproved.svg'
import inProgressImg from 'src/assets/Endorsement_images/inProgress.svg'
import cancelImg from 'src/assets/Endorsement_images/Group_102.svg'
import detailsCorrection from 'src/assets/Endorsement_images/detailsCorrection.svg'
import employeeCorrection from 'src/assets/Endorsement_images/employeeCorrection.svg'
import policyCorrection from 'src/assets/Endorsement_images/policyCorrection.svg'
import assetCorrection from 'src/assets/Endorsement_images/assetCorrection.svg'
import assetDetails from 'src/assets/Endorsement_images/assetDetails.svg'
import NoDataPic from 'src/assets/Endorsement_images/NoData.svg'
import { useQuery } from '@apollo/client'
import { useSelector } from 'react-redux'
import { COLORS } from 'src/utils/Themes/colors'
import { INSURANCE_DETAILS } from 'src/utils/constants/InsuranceDetails'
import 'src/App.css'
import ImageText from 'src/components/common/ImageText'
import {
  GET_ALL_ENDORSEMENTS,
  invokeAllTypesSXP,
} from 'src/services/individualService'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import documentDownload from 'src/utils/commonMethods/documentDownload'
import infoHover from 'src/assets/PolicyTile_Images/Group9.svg'
import {
  getClientType,
  getClientTypeUrl,
  isCorporatePOC,
} from 'src/utils/commonMethods'
import keycloak from 'src/utils/commonMethods/keycloak'
import { SXP_UPLOAD_POLICY_TYPE } from 'src/utils/constants/common'
import {
  ENDORSEMENT_TYPES,
  options,
  options1,
} from 'src/utils/constants/Individual'

const headCells = [
  { id: 'pic', label: '', disableSorting: true },
  { id: 'endorsementType', label: 'Type' },
  { id: 'endorsementStatus', label: 'Status', disableSorting: true },
  { id: 'endorsementCopy', label: 'Endorsement Copy', disableSorting: true },
  { id: 'submittedDetails', label: 'Submitted Details', disableSorting: true },
]
const endorsementImages = {
  'Policy Correction': policyCorrection,
  'Employee Addition & Deletion': employeeCorrection,
  'Employee Details Correction': detailsCorrection,
  'Asset Addition & Deletion': assetCorrection,
  'Asset Details Correction': assetDetails,
  'Individual Addition & Deletion': employeeCorrection,
  'Individual Details Correction': detailsCorrection,
}

const AllEndorsements = ({ clientId, clientType, policyType }) => {
  const classes = useStyles()
  const [page, setPage] = useState(0)
  const [rowsPerPage] = useState(20)
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('')
  let sortField = 'updatedOn'
  let sortOrder = 'desc'
  const userInfo = useSelector((usrState) => usrState?.userInfo)

  const getClientId = () => {
    if (clientId) {
      return clientId
    }
    return userInfo?.userInfo?.userData?.mobileNumber
      ? userInfo?.userInfo?.userData?.mobileNumber
      : userInfo?.userName
  }

  // const getUrl = () => {
  //   if (clientId) {
  //     return `dashboard/TaskDetails/company`;
  //   }
  //   return `dashboard/home`;
  // };

  const invokeRequestInitialSxp = (
    empId,
    empName,
    clientEndorsement,
    endorsementId,
    endorsementType,
    totalPolicy
  ) => {
    const sxpRequestBody = {
      state: {
        clientId: getClientId(),
        clientType: getClientType(clientType, userInfo),
        documentType: totalPolicy?.insuranceType,
        createdBy: userInfo?.userName,
        updatedBy: userInfo?.userName,
        requestTypeId: totalPolicy?.id,
        policy: totalPolicy,
        employeeName: empName,
        employeeId: empId,
        clientEndorsement: clientEndorsement,
        endorsementId: endorsementId,
        endorsementType: endorseType(endorsementType),
        sysAnnexureDocumentURL: totalPolicy?.sysAnnexureDocumentURL,
        sysAnnexureDocument: totalPolicy?.sysAnnexureDocument,
        email: userInfo?.userInfo?.userData?.emailId,
        roles: userInfo?.userInfo?.userData?.roles,
        policyType: policyType,
        token: keycloak?.token,
        clientTypeUrl: getClientTypeUrl(getClientType(clientType, userInfo)),
        url: 'dashboard/company',
      },
      userId: userInfo?.userName,
    }
    invokeAllTypesSXP(sxpRequestBody, userInfo?.userName, 'endorsementApproved')
  }
  const endorseType = (value) => {
    if (
      value === ENDORSEMENT_TYPES?.EMPLOYEE_ADDITION_DELETION ||
      value === ENDORSEMENT_TYPES?.ASSET_ADDITION_DELETION ||
      value === ENDORSEMENT_TYPES?.INDIVIDUAL_ADDITION_DELETION
    ) {
      return ENDORSEMENT_TYPES?.ENDORSEMENT_ADDITION_DELETION
    } else if (
      value === ENDORSEMENT_TYPES?.EMPLOYEE_DETAIL_CORRECTION ||
      value === ENDORSEMENT_TYPES?.ASSET_DETAIL_CORRECTION ||
      value === ENDORSEMENT_TYPES?.INDIVIDUAL_DETAIL_CORRECTION
    ) {
      return ENDORSEMENT_TYPES?.ENDORSEMENT_DETAIL_CORRECTION
    } else {
      return ENDORSEMENT_TYPES?.ENDORSEMENT_POLICY_CORRECTION
    }
  }

  const { loading, error, data, refetch } = useQuery(GET_ALL_ENDORSEMENTS(), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    variables: {
      page: page,
      sortField: sortField,
      sort: sortOrder,
      clientId: getClientId(),
      clientType: clientType,
    },
  })

  if (loading)
    return (
      <div className={'loadingContainer'}>
        <CircularProgress />
      </div>
    )
  if (error) return <GraphQlErrors error={error} routeValue={'back'} />

  const rows = data?.getAllEndorsements?.content

  const dateFormat = (date) => {
    const dateArray = new Date(date)
      ?.toLocaleString('en-IN', options)
      ?.split(' ')
    return dateArray?.join('-')
  }

  const timeFormat = (time) => {
    const dateArray1 = new Date(time)
      ?.toLocaleString('en-IN', options1)
      ?.split(' ')
    return dateArray1?.join('')
  }

  const handleSortRequest = (cellId) => {
    const isAsc = orderBy === cellId && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(cellId)

    refetch({
      sortField: cellId,
      sort: order,
    })
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleDocumentDownload = async (document, documentURL) => {
    documentDownload(document ? document : [], documentURL)
  }

  const TblPagination = () => (
    <TablePagination
      id={'tablePagination'}
      rowsPerPageOptions={[20]}
      component='div'
      page={page}
      rowsPerPage={rowsPerPage}
      count={data?.getAllEndorsements?.pageInfo?.totalCount}
      onPageChange={handleChangePage}
    />
  )

  const empDetails = (row) => {
    if (row.metadata) {
      if (row?.metadata?.empId && row?.metadata?.firstName) {
        return (
          <>
            {row?.metadata?.empId} {row?.metadata?.firstName}
          </>
        )
      } else {
        return <>----</>
      }
    } else {
      return <>----</>
    }
  }

  const tableHead = () => {
    return (
      <TableHead className={classes.tableHeadContainer}>
        <TableRow className={classes.tableRowContainer}>
          {headCells?.map((headCell) => (
            <TableCell
              className={classes.columnCSS}
              key={headCell?.id}
              sortDirection={orderBy === headCell?.id ? order : false}
            >
              {headCell?.disableSorting ? (
                headCell?.label
              ) : (
                <TableSortLabel
                  active={orderBy === headCell?.id}
                  direction={orderBy === headCell?.id ? order : 'asc'}
                  onClick={() => {
                    handleSortRequest(headCell?.id)
                  }}
                  id={'tableSortLabel'}
                >
                  {headCell?.label}
                </TableSortLabel>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    )
  }

  const nameConcat = (x) => {
    if (x === null) {
      return ''
    } else {
      let middle = x?.middleName
      if (x?.middleName === null) {
        middle = ''
      }
      return x?.firstName + ' ' + middle + ' ' + x?.lastName
    }
  }

  return (
    <>
      {(() => {
        if (rows?.length === 0) {
          return (
            <ImageText
              image={NoDataPic}
              display={'grid'}
              buttonText='No Endorsement Requests'
              // callinvokeSxp={invokeSxp}
              margin={'-10px'}
            />
          )
        } else {
          return (
            <>
              <Box className={classes.filterContainer}>
                <div className={classes.filterCheckDiv}>
                  <Grid className={classes.filterCheckGrid}></Grid>
                </div>
                <div className={classes.tableMainContainer}>
                  <Paper className={classes.root}>
                    <Table
                      className={`${classes.table} customTableCss ${classes.tableContainer}`}
                      stickyHeader
                      aria-label='sticky table'
                    >
                      {tableHead()}
                      <TableBody></TableBody>
                    </Table>
                  </Paper>
                </div>
                <div className={classes.endorsementTableDiv}>
                  <Paper className={classes.root}>
                    <Table
                      className={`${classes.table} customTableCss ${classes.tableRowsContainer}`}
                      stickyHeader
                      aria-label='sticky table'
                    >
                      <TableBody>
                        {rows?.map((row) => (
                          <TableRow
                            key={row.name}
                            className={classes.tableRowEach}
                          >
                            <TableCell component='td' scope='row'>
                              <img
                                src={endorsementImages[row?.endorsementType]}
                                className={`${classes.callImage} ${classes.endorsementImg}`}
                                alt={'endorsementType'}
                              />
                            </TableCell>
                            <TableCell>
                              <div
                                className={classes.endorsementPolicyContainer}
                              ></div>
                              <div className={classes.type2}>
                                {row?.endorsementType} {'('}
                                {row?.policy?.insuranceType}
                                {')'}
                              </div>
                              <div className={classes.requestedDate}>
                                {dateFormat(row?.createdOn) +
                                  ' / ' +
                                  timeFormat(row?.createdOn)}
                              </div>
                            </TableCell>

                            <TableCell>
                              <Grid className={classes.statusBar}>
                                {(() => {
                                  if (
                                    row?.endorsementStatus ===
                                    INSURANCE_DETAILS?.REQUEST_APPROVED
                                  ) {
                                    return (
                                      <img
                                        src={ApprovedImg}
                                        className={classes.stateImage}
                                        alt={'ApprovedImg'}
                                      />
                                    )
                                  } else if (
                                    row?.endorsementStatus ===
                                    INSURANCE_DETAILS?.REQUEST_SUBMITTED
                                  ) {
                                    return (
                                      <img
                                        src={blueApprovedImg}
                                        className={classes.stateImage}
                                        alt={'blueApprovedImg'}
                                      />
                                    )
                                  } else if (
                                    row?.endorsementStatus ===
                                      INSURANCE_DETAILS?.IN_PROGRESS ||
                                    row?.endorsementStatus ===
                                      INSURANCE_DETAILS?.ADDITIONAL_INFORMATION_REQUIRED
                                  ) {
                                    return (
                                      <img
                                        src={inProgressImg}
                                        className={classes.stateImage}
                                        alt={'inProgressImg'}
                                      />
                                    )
                                  } else if (
                                    row?.endorsementStatus ===
                                    INSURANCE_DETAILS?.REQUEST_REJECTED
                                  ) {
                                    return (
                                      <img
                                        src={cancelImg}
                                        className={classes.stateImage}
                                        alt={'cancelImg'}
                                      />
                                    )
                                  }
                                })()}
                                <Grid className={classes.status}>
                                  {row?.endorsementStatus ===
                                    INSURANCE_DETAILS?.REQUEST_INITIATED &&
                                  isCorporatePOC(
                                    userInfo?.userInfo?.userData?.roles
                                  ) &&
                                  policyType ===
                                    SXP_UPLOAD_POLICY_TYPE?.CORPORATE ? (
                                    <>
                                      <Button
                                        className={classes.renewButton1}
                                        id={'approvalButton'}
                                        onClick={() =>
                                          invokeRequestInitialSxp(
                                            row?.metadata?.empId,
                                            nameConcat(row?.metadata),
                                            row?.clientEndorsement,
                                            row?.id,
                                            row?.endorsementType,
                                            row?.policy
                                          )
                                        }
                                      >
                                        {INSURANCE_DETAILS?.NEED_APPROVAL}
                                      </Button>
                                      <Tooltip
                                        TransitionComponent={Zoom}
                                        placement='top'
                                        title={empDetails(row)}
                                        arrow
                                      >
                                        <img
                                          className={classes.logoPic}
                                          src={infoHover}
                                          alt={'paisaplanLogo'}
                                        />
                                      </Tooltip>
                                    </>
                                  ) : (
                                    <>{row?.endorsementStatus}</>
                                  )}
                                  <div className={classes.stateDate}>
                                    {row?.updatedOn == null
                                      ? null
                                      : dateFormat(row?.updatedOn) +
                                        ' / ' +
                                        timeFormat(row?.updatedOn)}
                                  </div>
                                </Grid>
                              </Grid>
                            </TableCell>
                            <TableCell>
                              {row?.agentEndorsement?.length ? (
                                <div className={classes.endorsementContainer}>
                                  <span className='cursor-pointer'>
                                    <img
                                      id='agentEndorsementDownload'
                                      src={endorsementImg}
                                      className={classes.callImage}
                                      alt={'endorsementImg'}
                                      onClick={() =>
                                        handleDocumentDownload(
                                          row?.agentEndorsement,
                                          row?.agentEndorsementCopy
                                        )
                                      }
                                    ></img>
                                  </span>
                                </div>
                              ) : (
                                <div className={classes.endorsementException}>
                                  {'-'}
                                </div>
                              )}
                            </TableCell>
                            <TableCell>
                              <div className={classes.handleDocumentContainer}>
                                <span className='cursor-pointer'>
                                  <img
                                    id='submittedImg'
                                    src={submittedImg}
                                    className={classes.callImage}
                                    alt={'submittedImg'}
                                    onClick={() =>
                                      handleDocumentDownload(
                                        row?.clientEndorsement,
                                        row?.clientEndorsementDoc
                                      )
                                    }
                                  />
                                </span>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Paper>
                </div>
              </Box>
              <TblPagination />
            </>
          )
        }
      })()}
    </>
  )
}

export default AllEndorsements
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(3),
  },
  root: {
    width: '100%',
    // marginTop: theme.spacing(),
  },
  tableRowEach: {
    '&:last-child td, &:last-child th': { border: 0 },
  },
  tableHeadContainer: {
    '& .MuiTableCell-root': { padding: '0px 10px 0px 10px' },
  },
  tableRowContainer: {
    '& .MuiTableCell-root': { padding: '10px !important' },
  },
  table: {
    minWidth: 650,
  },
  endorsementException: {
    marginLeft: '22%',
  },
  handleDocumentContainer: {
    marginLeft: '0px',
    width: '',
  },
  endorsementContainer: {
    marginLeft: '0px',
  },
  endorsementPolicyContainer: {},
  tableMainContainer: {
    // height: "50vh",
    width: '65vw',
    overflowX: 'auto',
    // overflowY: "auto",
  },
  tableContainer: {
    '& .MuiTableCell-root': {
      padding: '20px 10px 20px 10px',
    },
  },
  columnCSS: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '400 !important',
    fontSize: '10px !important',
    color: 'rgba(51, 51, 51, 0.7)!important',
    backgroundColor: '#DDDDDD',
    whiteSpace: 'nowrap',
  },
  filterContainer: {
    '& .MuiDataGrid-root .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer':
      {
        width: 'auto',
        visibility: 'visible',
      },
    '& .MuiDataGrid-root .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon':
      {
        opacity: 0.5,
      },
    '& .MuiTableSortLabel-icon': {
      opacity: 5.5,
    },
  },
  type1: {
    fontWeight: '500 !important',
    fontSize: '12px',
    color: COLORS.MEDIUM_BLUE,
  },
  type2: {
    textTransform: 'capitalize',
    fontWeight: '600 !important',
    fontSize: '15px',
    color: COLORS.MEDIUM_BLUE,
    marginTop: '-5px !important',
    '@media (max-width:1550px)': {
      fontSize: '13px',
    },
  },

  tableRowsContainer: {
    '& .MuiTableCell-root': {
      padding: '20px 10px 20px 10px',
    },
  },
  endorsementImg: {
    padding: '0px 0px 0px 20px',
  },
  requestedDate: {
    fontWeight: '400',
    fontSize: '13px',
    color: '#112F3C !important',
    '@media (max-width:1550px)': {
      fontSize: '12px',
    },
  },
  status: {
    marginLeft: '10px',
    fontWeight: '600',
    fontSize: '13px',
    color: '#112F3C !important',
    flexWrap: 'wrap',
    '@media (max-width:1550px)': {
      fontSize: '12px',
      display: 'flex',
      textAlign: 'center',
    },
  },
  stateDate: {
    fontWeight: '500 !important',
    fontSize: '12px',
    color: COLORS.MEDIUM_BLUE,
    '@media (max-width:1550px)': {
      fontSize: '11px',
    },
  },
  callImage: {
    '@media (max-width:1500px)': {
      height: '27px',
    },
  },
  stateImage: {
    marginTop: '3%',
    '@media (max-width:1500px)': {
      height: '20px',
    },
  },
  filterCheckDiv: {
    float: 'right',
    marginBottom: '5px',
  },
  filterCheckGrid: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  endorsementTableDiv: {
    height: '50vh',
    width: '65vw',
    overflowX: 'auto',
    overflowY: 'auto',
    borderRadius: '10px',
  },
  noData: {
    height: '40vh',
    width: '65vw',
    overflowX: 'auto',
    overflowY: 'auto',
  },
  renewButton1: {
    backgroundColor: COLORS.MEDIUM_BLUE,
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: 'bold',
    color: COLORS.WHITE,
    textTransform: 'unset',
    size: 'small',
    fontSize: '10px',
    borderRadius: '9px',
    border: '1px solid #112F3C',
    height: '25px',
    '&:hover': {
      backgroundColor: COLORS.MEDIUM_BLUE,
    },
  },
  logoPic: {
    width: '15px',
    paddingLeft: '5px',
    cursor: 'pointer',
  },
  statusBar: {
    display: 'flex',
    alignItems: 'center',
  },
}))
